exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-62ffe0e8] {\n  font-weight: 800;\n  color: black;\n}\n.form-control[data-v-62ffe0e8]:focus {\n  border-color: #7BE855;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(123, 232, 85, 0.6);\n}\n.form-control.error[data-v-62ffe0e8] {\n  border-color: #E84444;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(232, 68, 68, 0.6);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62ffe0e8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/importCSV/importMoveOrders/importMoveOrders.component.scss
// module id = 1322
// module chunks = 0